<template>
  <div class="vue-modal-dialog-mask" :class="$style.modal">
    <div class="vue-modal-dialog-content">
      <header>
        Transcribe this conversation in
        <button
          type="button"
          @click="$close(true)"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
        >
          <FontAwesomeIcon :icon="faTimes" />
        </button>
      </header>
      <div>
        <div :class="$style.formGroup">
          <multiselect
            v-model="value"
            label="label"
            track-by="locale"
            placeholder="Please select"
            :allow-empty="false"
            :show-labels="false"
            :options="team.languages"
          >
            <template #noResult>
              <span>No matches found</span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-components/vue-multiselect";
import { createNamespacedHelpers } from "vuex";
import { successNotification, errorNotification } from "../../notifications";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";

const { mapState } = createNamespacedHelpers("activitySummary");

export default {
  components: {
    Multiselect,
    FontAwesomeIcon,
  },
  data() {
    return {
      faTimes,
      selectedLanguage: null,
      user: this.$_activitySummary_config.getUser(),
      team: this.$_activitySummary_config.getTeam(),
      error: null,
    };
  },
  computed: {
    ...mapState(["activity"]),
    value: {
      get() {
        return this.selectedLanguage || this.defaultLanguage;
      },
      async set(option) {
        try {
          this.error = null;
          await axios.put(
            `${this.$_activitySummary_config.jiminnyHost()}/api/v1/activity/${
              this.activity.id
            }`,
            {
              language: option.locale,
            }
          );
          this.selectedLanguage = option;
          this.closeModal();
          successNotification({
            message: `Language changed to ${option.label} successfully`,
          }).show();
        } catch (error) {
          errorNotification({
            message: "Something went wrong. Please try again later.",
          }).show();
        }
      },
    },
    defaultLanguage() {
      return (
        this.team.languages.find(
          (language) => language.locale === this.activity.language
        ) ||
        this.team.languages.find(
          (language) => language.locale === this.user.language
        )
      );
    },
  },
  methods: {
    closeModal() {
      this.$close(true);
    },
  },
};
</script>

<style module lang="less" src="./ChangeTranscriptionLanguageModal.less"></style>



// WEBPACK FOOTER //
// ChangeTranscriptionLanguageModal.vue?4fde0d80